import React, { useState } from 'react'
import { Button, Col, Container, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AiFillDelete } from 'react-icons/ai'
import { FiUpload } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { addImages, deleteImage } from '../../Redux/features/User/userSlice';
import { useDispatch } from 'react-redux';
import FormData from 'form-data';
import key from '../../key';
import axios from 'axios';

function PhotoAlbum({ user }) {
    const [hoveredPhotoIndex, setHoveredPhotoIndex] = useState(null);
    const [image, setImage] = useState(null);
    const dispatch = useDispatch();
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);


    const handleAddPhoto = async() => {
        if (image) {
            const dataa = new FormData();
            const filename = Date.now() + image.name;
            dataa.append("name", filename);
            dataa.append("file", image);
            try {
                await axios.post(`${key}/api/upload`, dataa);
            } catch (err) {
                console.log("err>>>", err);
            }
            let photo;
            if(user.photos[0].url === "sample-image.png"){
                photo = []
            }else{
                photo = user.photos;
            }
            let img = {url: filename}
            let photos = [...photo, img]
            let data ={
                photos: {
                    images: photos
                },
                header:cookies['x-auth-token']
            }
            dispatch(addImages(data));
        }
    };



    const handlePhotoMouseEnter = (index) => {
        setHoveredPhotoIndex(index);
    }

    const handlePhotoMouseLeave = () => {
        setHoveredPhotoIndex(null);
    }

    const handleDeletePhoto = async (id) => {
        let data ={
            image:{
                url:id
            },
            header:cookies['x-auth-token']
        }
        try {
            await axios.delete(`${key}/api/delete/${id}`);
        } catch (error) {
            console.log(error);
        }
        dispatch(deleteImage(data))
    }



    return (
        <Container fluid className='photoAlbum'>
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <div className="d-grid gap-2 my-3">
                        <label className="fw-bold w-25 mx-auto primary-btn p-2" style={{cursor:"pointer",borderRadius:6,color:"white"}}>
                            <FiUpload size={25} />
                            Upload Photo
                            <input
                                style={{ display: "none" }}
                                type="file"
                                name="images"
                                onChange={(e) => setImage(e.target.files[0])}
                                accept="image/png , image/jpeg, image/webp"
                            />
                        </label>
                        <img width={200} className=""
                            src={
                                image
                                    ? URL.createObjectURL(image)
                                    : ``
                            } alt="" />
                        {image && <Button className='fw-bold w-25 mx-auto primary-btn' onClick={handleAddPhoto}>
                            Add Photo
                        </Button>}
                        {/* <input type="file" onChange={handleImageUpload} />
                        <Form.Control
                            type="file"
                            accept="image/*"
                            className="d-none"
                            ref={fileInputRef}
                            onChange={handleFileInputChange}
                            multiple
                        /> */}

                    </div>
                    <div className='photosText'>Note: You can upload 20 photos to your profile. Each photos must be less than 15 MB and in jpg, jpeg, png or webp format. All photos uploaded are screened as per <Link>Photo Guidelines</Link> and 98% of those get activated within 2 hours.</div>
                    <Row className="g-3">
                        {user.photos.map((photo, i) => (
                            <Col key={i} xs={12} sm={6} md={4}>
                                <div
                                    className="photo-container"
                                    onMouseEnter={() => handlePhotoMouseEnter(i)}
                                    onMouseLeave={handlePhotoMouseLeave}
                                >
                                    <img src={`${key}/images/${photo.url}`} alt="notFound" className="img-fluid rounded" />
                                    {hoveredPhotoIndex === i && (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id={i}>Delete photo</Tooltip>}
                                        >
                                            <Button
                                                variant="danger"
                                                className="delete-button"
                                                onClick={() => handleDeletePhoto(photo.url)}
                                            >
                                                <AiFillDelete />
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
            <div className='text-center mt-5'><Link>Photo Guidelines</Link> | <Link>Photo FAQ</Link></div>
        </Container>
    )
}

export default PhotoAlbum